import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';
import { ApiService } from '../core/services/api.service';
import { HelperService} from './helper.service'
import { APIENDPOINTS } from '../common/constants';
import { MESSAGES } from '../core/constants/global.constants';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})

export class FileService {

  constructor(private apiService: ApiService, private config: ConfigService, private helperService: HelperService) {

  }

  public uploadFile(id: number, fileContent: any): Observable<any> {
    this.helperService.setLoader(true);
    const observable = this.apiService.uploadWithToken(this.config.gatewayBaseUrl + APIENDPOINTS.UPLOAD_QUOTE_FILE.replace("{id}", id.toString()), fileContent, false).pipe(tap(result => {
      this.helperService.toasterService.success(MESSAGES.UPLOAD_SUCCESS);
      this.helperService.setLoader(false);
    }, error => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.error(MESSAGES.UPLOAD_FAILURE);
      return error
    }));

    return observable;
  }

  public uploadRTMPFile(id: number, fileContent: any):Observable<any> {
    this.helperService.setLoader(true);
    const observable = this.apiService.uploadWithToken(this.config.gatewayBaseUrl + APIENDPOINTS.UPLOAD_RTMP_FILE.replace("{id}", id.toString()), fileContent, false).pipe(tap(result => {
      this.helperService.toasterService.success("Document has been uploaded successfully.");
      this.helperService.setLoader(false);
    }, error => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.error("Unable to upload the document.");
      return error
    }));

    return observable;
  }

  downloadFile(id: number, fileName: string) {
    this.helperService.setLoader(true);
    const apiEndpoint = this.config.gatewayBaseUrl + APIENDPOINTS.DOWNLOAD_QUOTE_FILE.replace("{id}", id.toString());
    this.apiService.download<any>(apiEndpoint, false).subscribe(result => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.success(MESSAGES.DOWNLOAD_SUCCESS);
      FileSaver.saveAs(result, fileName);
    }, error => {
      this.helperService.setLoader(false);
      if (!this.showBusinessRuleError(error)) {
        this.helperService.toasterService.error(MESSAGES.DOWNLOAD_FAILURE);
      }
      throw error;

    });
  }

   downloadQuote(id: number, quoteNumber: string) {
    this.helperService.setLoader(true);
    const apiEndpoint = this.config.gatewayBaseUrl + APIENDPOINTS.DOWNLOAD_QUOTE_STATEMENT.replace("{id}", id.toString());
    this.apiService.download<any>(apiEndpoint, false).subscribe(result => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.success(MESSAGES.DOWNLOAD_SUCCESS);
      FileSaver.saveAs(result, quoteNumber + '-QuoteStatement.pdf');
    }, error => {
      this.helperService.setLoader(false);
      if (!this.showBusinessRuleError(error)) {
        this.helperService.toasterService.error(MESSAGES.DOWNLOAD_FAILURE);
      }
      throw error;

    });
  }

  downloadRFQ(id: number, quoteNumber: string) {
    this.helperService.setLoader(true);
    const apiEndpoint = this.config.gatewayBaseUrl + APIENDPOINTS.DOWNLOAD_QUOTE_RFQ
          .replace("{referenceNumber}",quoteNumber)
          .replace("{id}", id.toString());

    this.apiService.download<any>(apiEndpoint, false).subscribe(result => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.success(MESSAGES.DOWNLOAD_SUCCESS);
      FileSaver.saveAs(result, quoteNumber + '-QuoteRFQ.pdf');
    }, error => {
      this.helperService.setLoader(false);
      if (!this.showBusinessRuleError(error)) {
        this.helperService.toasterService.error(MESSAGES.DOWNLOAD_FAILURE);
      }
      throw error;

    });
  }

  downloadRTMP(id: number, BCFNumber: string) {
    this.helperService.setLoader(true);
    const apiEndpoint = this.config.gatewayBaseUrl + APIENDPOINTS.DOWNLOAD_RTMP
          .replace("{referenceNumber}",BCFNumber)
          .replace("{id}", id.toString());

    this.apiService.download<any>(apiEndpoint, false).subscribe(result => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.success(MESSAGES.DOWNLOAD_SUCCESS);
      FileSaver.saveAs(result, 'RTMP-application-' + BCFNumber + '.pdf');
    }, error => {
      this.helperService.setLoader(false);
      if (!this.showBusinessRuleError(error)) {
        this.helperService.toasterService.error(MESSAGES.DOWNLOAD_FAILURE);
      }
      throw error;
    });
  }

  

  downloadCertificate(id: number, bcfNumber: string) {
    this.helperService.setLoader(true);
    const apiEndpoint = this.config.gatewayBaseUrl + APIENDPOINTS.DOWNLOAD_PAYMENT_CERTIFICATE
          .replace("{referenceNumber}",bcfNumber)
          .replace("{id}", id.toString());

    this.apiService.download<any>(apiEndpoint, false).subscribe(result => {
      this.helperService.setLoader(false);
      this.helperService.toasterService.success(MESSAGES.DOWNLOAD_SUCCESS);
      FileSaver.saveAs(result, 'payment-certificate-' + bcfNumber + '.pdf');
    }, error => {
      this.helperService.setLoader(false);
      if (!this.showBusinessRuleError(error)) {
        this.helperService.toasterService.error(MESSAGES.DOWNLOAD_FAILURE);
      }
      throw error;

    });
  }

  private showBusinessRuleError(error: any): boolean {
    if (!error || error.status !== 422) {
      return false;
    }

    const errorBody = error.error;
    if (errorBody instanceof Blob) {
      errorBody.text().then((text: string) => {
        const parsedMessage = this.extractErrorMessageFromText(text);
        this.helperService.toasterService.error(parsedMessage || MESSAGES.DOWNLOAD_FAILURE);
      }).catch(() => {
        this.helperService.toasterService.error(MESSAGES.DOWNLOAD_FAILURE);
      });
      return true;
    }

    const message = this.extractErrorMessage(errorBody);
    if (message) {
      this.helperService.toasterService.error(message);
      return true;
    }

    return false;
  }

  private extractErrorMessageFromText(text: string): string {
    if (!text) {
      return '';
    }

    try {
      return this.extractErrorMessage(JSON.parse(text));
    } catch {
      return this.getFirstTwoLines(text);
    }
  }

  private extractErrorMessage(errorBody: any): string {
    if (!errorBody) {
      return '';
    }
    if (typeof errorBody === 'string') {
      return this.getFirstTwoLines(errorBody);
    }

    if (errorBody.message && typeof errorBody.message === 'string') {
      return this.getFirstTwoLines(errorBody.message);
    }

    if (errorBody.detail && typeof errorBody.detail === 'string') {
      return this.getFirstTwoLines(errorBody.detail);
    }

    if (errorBody.title && typeof errorBody.title === 'string') {
      return this.getFirstTwoLines(errorBody.title);
    }

    if (errorBody.errors) {
      const firstKey = Object.keys(errorBody.errors)[0];
      if (firstKey && Array.isArray(errorBody.errors[firstKey]) && errorBody.errors[firstKey].length > 0) {
        return this.getFirstTwoLines(errorBody.errors[firstKey][0]);
      }
    }

    return '';
  }

  private getFirstTwoLines(message: string): string {
    if (!message) {
      return '';
    }

    const lines = message
      .replace(/\r/g, '\n')
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    return lines.slice(0, 2).join('\n');
  }

  

}
